import { useFetchRemoteNotificationsConfigsFunc } from './types';

export const useFetchRemoteNotificationsConfigs: useFetchRemoteNotificationsConfigsFunc = () => {
  return {
    isLoading: false,
    fetchRemoteNotificationsConfigs: async () => undefined,
  };
};
